const quickLinks = [
  { label: "正在发生", href: "#home" },
  { label: "实时热榜", href: "#toplist" },
  { label: "深度专题", href: "#feature" },
  { label: "热门频道", href: "#channels" },
  { label: "帮助答疑", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

const chanLinks = [
  { label: "文娱圈速报", href: "#channels" },
  { label: "影视一线", href: "#channels" },
  { label: "音乐现场", href: "#channels" },
  { label: "科技大瓜", href: "#channels" },
  { label: "直播间风向", href: "#channels" },
  { label: "生活潮流", href: "#channels" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-14 bg-primary-800 text-primary-100" aria-label="页脚">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-10 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        {/* brand */}
        <div>
          <a href="#home" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50 text-primary-700">
              <i className="ri-focus-2-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-background-50">吃瓜在线</span>
              <span className="text-[10px] tracking-[0.24em] text-primary-200">热点 · 一手 · 持续更新</span>
            </span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-primary-200">
            全网热点实时更新，即时爆料与滚动更新并行。从最新进展到事件全貌，一手消息持续追踪，想第一时间知道正在发生什么，锁定这里就够了。
          </p>
          <div className="mt-4 flex items-center gap-2">
            {[
              { icon: "ri-wechat-line", label: "微信" },
              { icon: "ri-weibo-line", label: "微博" },
              { icon: "ri-bilibili-line", label: "哔哩哔哩" },
              { icon: "ri-tiktok-line", label: "抖音" },
            ].map((s) => (
              <a
                key={s.label}
                href="#about"
                aria-label={s.label}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10 text-sm transition-colors hover:bg-background-50/25"
              >
                <i className={s.icon} />
              </a>
            ))}
          </div>
        </div>

        {/* quick links */}
        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">快速导航</h3>
          <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-primary-200 transition-colors hover:text-background-50">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* channels */}
        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">热门频道</h3>
          <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {chanLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-primary-200 transition-colors hover:text-background-50">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* contact */}
        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">联系我们</h3>
          <ul className="mt-3 space-y-2.5 text-sm text-primary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-background-50/80" />
              hello@chiigua.example.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-background-50/80" />
              工作日 09:00 – 21:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-focus-3-line text-background-50/80" />
              全网热点 · 实时滚动更新
            </li>
          </ul>
          <a
            href="#subscribe"
            className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-add-line" />
            订阅热点提醒
          </a>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-primary-200 sm:flex-row md:px-6">
          <p>© 2026 吃瓜在线 · 全网热点实时追踪平台</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-verified-badge-line text-accent-300" />
            还原 · 求证 · 不站队
          </p>
        </div>
      </div>
    </footer>
  );
}